var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`grid__wrapper ${_vm.tight ? 'grid__wrapper--tight' : ''} ${_vm.spread ? 'grid__wrapper--spread' : ''}`},[_c('div',{class:_vm.className,style:(_vm.style)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }